var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareMapsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.48 4.47 0 10 0C15.52 0 20 4.48 20 10C20 15.53 15.52 20 10 20C4.47 20 0 15.53 0 10ZM12.23 11.83L13.85 6.71C13.8756 6.63162 13.8792 6.54771 13.8604 6.46742C13.8416 6.38714 13.8011 6.31357 13.7433 6.25474C13.6855 6.19592 13.6127 6.15411 13.5327 6.13387C13.4528 6.11364 13.3688 6.11576 13.29 6.14L8.17 7.74C7.96 7.81 7.79 7.97 7.73 8.18L6.13 13.31C6.02 13.65 6.35 13.98 6.69 13.87L11.79 12.27C12 12.21 12.17 12.04 12.23 11.83Z",
    fill: "#A7ADB7",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMapsvg);
export default __webpack_public_path__ + "static/media/share-map.svg.0b87e140e237ea702c3270b916038794.svg";
export { ForwardRef as ReactComponent };